import { Box, VStack, Heading, Text, Image } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { t } from "i18next";
import { useRef, useState } from "react";
import CustomModalPlus from "../customModalPlus";
import Arrow from '../../../assets/images/Caret.png';
import blueArrow from '../../../assets/images/arrow.png';
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { addLineBreaks } from "../../../utils";
import logFirebaseEvents from "../../../components/LogFirebaseEvents";
import buttonBorder from '../../../assets/kudzu-plus-images/gradient-button-square.png';
import LeftArrow from '../../../assets/images/left_arrow.png';
import RightArrow from '../../../assets/images/Right_arrow.png'

const Slide = ({ heading, paragraph, imageUrl,imageUrlAlter, videoUrl, footerText, imageCenter, dotsAbove, carouselAcceptBtnText, carouselCancelBtnText, carouselAcceptBtnClick, carouselCancelBtnClick, slidesData, currentSlide,slickRef,isbgTransparent,dynamicfooterStyles,dynamicSubHeaderStyles,dynamicHeaderStyles , width, slackListHeight="auto"}) => {
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal ";//md:h-[92px]
  const SubHeaderMsgStyles = "sm:w-[399px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]";
  const SubHeaderMsgStylesFooter = "font-hanken-grotesk modal-title text-white  lg:text-[15px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]";
 
  const handleDotClick = (index) => {
    slickRef.current.slickGoTo(index); 
  };

  return (
    <VStack
      bg={isbgTransparent ? '' : '#262B3A'}
      border=""
      align="center"
      justify="center"
      gap="15px"
      height={slackListHeight}
    >
      <Heading as="h6"
        className={`${dynamicHeaderStyles ? dynamicHeaderStyles : HeaderMsgStyles} ${isbgTransparent ? 'text-[#262B3A]' : 'text-white'}`}
        marginRight={"auto"}
      >
        {heading}
      </Heading>
      <p
        className={dynamicSubHeaderStyles ? dynamicSubHeaderStyles : SubHeaderMsgStyles}
        style={{ marginRight: "auto", }}
      >
        {paragraph}
      </p>


      {dotsAbove && slidesData?.length > 0 && (
        <ul className="slick-top-dots" style={{ display: 'block' }}>
          {slidesData.map((slide, index) => (
            <li key={index} className={currentSlide === index ? 'slick-active' : ''} onClick={() => handleDotClick(index)}>
              <button>{index + 1}</button>
            </li>
          ))}
        </ul>
      )}


      {imageUrl ? (
        <Image className={`bgVid w-260px h-260px md:mr-5`} src={imageUrl} alt={heading}   />
      ) : (
        <video
          className={`${imageCenter ? footerText ? '' : '' : ''} w-full h-auto`}
          alt={heading}
          style={{ maxHeight: "299px", maxWidth: "299px", background: "transparent" }}
          autoPlay
          muted
          loop
          preload="auto"
          playsInline>
          <source src={videoUrl} type="video/mp4" />
        </video>
      )}
      {
        imageUrlAlter &&(<Image className={`bgVid w-500px h-500px md:mr-5`} src={imageUrlAlter} alt={heading}   />)
      }

      {footerText && (
        <div className={`${dynamicfooterStyles ? dynamicfooterStyles : SubHeaderMsgStylesFooter}`} marginRight={"auto"}>
          {footerText}
        </div>
      )}
    </VStack>
  );
};
 
export default function CustomCarousel({ slidesData, acceptBtnClr, onCancelBtnClickPlusModal, gradientButton, footerTexts, footerbtnContent, finalButtontextChange, forClimbHomeBtn, dotsAbove, forClimbBtn, buttonsEnableForWelcome, ManageMembershipKudzuPlusBtns,isbgTransparent = false, forWelcomeCarousel, dotsHide = false,kudzuplusCheckOnClick,iswelcomeCarouselSkipClick,climNextCallBack, isClimbMenu=false}) {
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-white lg:text-[15px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300] cursor-pointer";
  const SubHeaderMsgStylesFooter = "font-hanken-grotesk modal-title text-[var(--modal-text-heading-clr)]  lg:text-[15px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]";
  
  const slickRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const kudzuFlowFromVal = useSelector(state => state.kudzuFlowFrom);


  const dispatch = useDispatch()

  const navigate = useNavigate()

  const slickSettings = {
    // dots: !dotsAbove ,
    dots: dotsAbove ? false : dotsHide ? false : true ,
    infinite: true,
    speed: 600,
    autoplay: dotsAbove ? false : false,
    slidesToShow: 1,
    arrows: false,
    afterChange: (current) => setCurrentSlide(current),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const nextSlide = () => {
    slickRef.current.slickNext();
  };

  const navigateToHome = () => {
    navigate('/home')
  }

  const handleSkip = () => {
    logFirebaseEvents("Carousel", "Skip_Clicked", "Skip_Clicked", "", "");
    if (kudzuFlowFromVal === "Climb" || kudzuFlowFromVal === "climbCoveredByKudzu" || kudzuFlowFromVal === "climFooter" || kudzuFlowFromVal === t('change_pin_success')) {
      if (onCancelBtnClickPlusModal) {
        onCancelBtnClickPlusModal()
      }
    }
    else {
      // navigate('/home')
      onCancelBtnClickPlusModal()
    }
  }

  const handleSkipForWelcome = () => {
    navigate('/home')
  }

  const currentSlideData = slidesData[currentSlide] || {};


  return (
    <>
      <Box >
        <Box

          sx={{
            ".slick-list": {
            height: slidesData[currentSlide]?.slackListHeight || "auto", // Dynamic height
          },

            ".slick-dots": {
              top: dotsAbove ? "130px" : "",
              bottom: dotsAbove ? "inherit" : '-25px;'
            },

            ".slick-dots li": {
              width: "5px",
              height: "5px"
            },
            ".slick-dots li button::before": {
              color: "var(--card-bg-profile)", // Color for non-active dots
              fontSize: "6px", // Dot size
              transition: "none", // Disable hover effect
            },
            ".slick-dots li.slick-active button::before": {
              color: "white",
            },
            // Styling for arrows
            ".slick-prev, .slick-next": {
              width: "40px",
              height: "40px",
              zIndex: 1,
              display: "flex !important",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255, 255, 255, 0.2)", // Semi-transparent white background
              borderRadius: "50%", // Circular shape
              top: "50%", // Center vertically
              transform: "translateY(-50%)",
            },
            ".slick-prev": {
              left: "10px", // Position on the left
            },
            ".slick-next": {
              right: "10px", // Position on the right
            },
            ".slick-prev:before, .slick-next:before": {
              display: "none", // Hide default arrows
            },
          }}
        >
          <Slider ref={slickRef} {...slickSettings}>
  
 {slidesData.map((slide, index) => (
              <Slide
                key={index}
                heading={slide.heading}
                paragraph={slide.paragraph}
                imageUrl={slide.imageUrl}
                imageUrlAlter={slide.imageUrlAlter}
                videoUrl={slide.videoUrl}
                footerText={slide.footerText}
                imageCenter={dotsAbove}
                isbgTransparent={isbgTransparent}
                dotsHide={dotsHide}
                dotsAbove={dotsAbove}
                slidesData={slidesData}
                currentSlide={currentSlide}
                slickRef={slickRef}
                carouselAcceptBtnText={slide.carouselAcceptBtnText}
                carouselCancelBtnClick={slide.carouselCancelBtnClick}
                carouselAcceptBtnClick={slide.carouselAcceptBtnClick}
                dynamicfooterStyles={slide.dynamicfooterStyles}
                dynamicSubHeaderStyles={slide.dynamicSubHeaderStyles}
                dynamicHeaderStyles={slide.dynamicHeaderStyles}
                slackListHeight={
                  slide.slackListHeight === undefined
                    ? "auto"
                    : slide.slackListHeight
                }
              />
            ))}
          </Slider>
              <div className="relative">
  <button
    className="absolute top-1/2 left-[10px] z-10"
    onClick={() => slickRef.current.slickPrev()}
  >
    <img
      src={LeftArrow}
      alt="Previous"
      className="w-[36px] h-[32px] ml-[50px]"
    />
  </button>
  <button
    className="absolute top-1/2 right-[10px] z-10 mr-[50px]"
    onClick={() => slickRef.current.slickNext()}
  >
    <img src={RightArrow} alt="Next" className="w-[36px] h-[32px]" />
  </button>

</div>
        </Box>
      </Box>

      {currentSlideData.footerTextForUpgrade && (<p className={currentSlideData.dynamicfooterStyles ? currentSlideData.dynamicfooterStyles : SubHeaderMsgStylesFooter} marginRight={"auto"}>
        {currentSlideData.footerTextForUpgrade}
      </p>)}

      {currentSlideData.carouselAcceptBtnText && (
        <button class="borderGradient md:w-[100%] w-full m-auto font-semibold mt-[40px] 
        flex items-center lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px]
         justify-center lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk 
         leading-[16px] focus:outline-none" onClick={currentSlideData.carouselAcceptBtnClick} style={{ color: 'rgb(255, 255, 255)' }}> {currentSlideData.carouselAcceptBtnText}</button>
      )}

      {currentSlideData.carouselCancelBtnText && (
        <button tabindex="0" id="btn2Ref" class=" w-full mt-5 lg:h-[60px] 
       md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px]
        md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] sm:border-0 border-[#2965FB]
         border-[0px] focus:border-[#2965FB] focus:border-[#3px]" onClick={currentSlideData.carouselCancelBtnClick}
          style={{ color: 'rgb(119, 156, 229)' }}>{currentSlideData.carouselCancelBtnText}</button>
      )}
  
  
       {/* WellCome carosals space */}
      {buttonsEnableForWelcome &&
        <div className='flex sm: justify-between md:gap-[18rem] xsm:gap-[130px] sm:gap-48 mt-[25px]'>
          <button
            type="button"
            onClick={handleSkipForWelcome}
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                          text-[#779CE5] flex items-center"

          >
            {t('skip')}
          </button>
          {currentSlide === slidesData.length - 1 ?
            <button
              type="button"
              onClick={navigateToHome}
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px]
                           text-white cursor-pointer flex items-center"
              style={{ fontWeight: 400 }}
            >
              {t('get_started')}<img
                src={Arrow}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                h-[14px] ml-1"
                alt="Arrow" />
            </button> : <button
              type="button"
              onClick={nextSlide}
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                               text-white cursor-pointer flex items-center"
              style={{ fontWeight: 400 }}
            >
              {t('next')}<img
                src={Arrow}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                    h-[14px] ml-1"
                alt="Arrow" />
            </button>}

        </div>}

      {forClimbBtn && !isClimbMenu &&
        <div className={`flex ${forClimbHomeBtn ? 'sm: justify-between' : 'sm: justify-end'} ${forClimbHomeBtn ? 'md:gap-[18rem]' : 'md:gap-[120px]'} xsm:gap-[130px] sm:gap-48 mt-[25px]`}>
          <button
            type="button"
            onClick={handleSkip}
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                          text-[#94C3E8] flex items-center"
            style={{ fontWeight: 600 }}
          >
            {t('skip')}
          </button>
          {currentSlide === slidesData.length - 1 ?
            <button
              type="button"
              onClick={() => {
                debugger
                logFirebaseEvents("Carousel", "learn_More_Clicked", "learn_More_Clicked", "", "");
                finalButtontextChange === t('done') ? onCancelBtnClickPlusModal() : climNextCallBack() 
              }}
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px]
                           text-white cursor-pointer flex items-center"
              style={{ fontWeight: 600 }}

            >
              {finalButtontextChange ? finalButtontextChange : t('Learn_More')}
              {finalButtontextChange === t('done') ? "" : <img
                src={Arrow}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                h-[14px] ml-1"
                alt="Arrow" />}
            </button> : <button
              type="button"
              onClick={nextSlide}
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                               text-white cursor-pointer flex items-center"
              style={{ fontWeight: 600 }}
            >
              {finalButtontextChange === t('done') ? t('next') : t('Learn_More')}
              <img
                src={Arrow}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                alt="Arrow" />
            </button>}

        </div>}

        {forClimbBtn && isClimbMenu && 
        <div className={`flex ${forClimbHomeBtn ? 'sm: justify-between' : 'sm: justify-end'} ${forClimbHomeBtn ? 'md:gap-[18rem]' : 'md:gap-[120px]'} xsm:gap-[130px] sm:gap-48 mt-[25px]`}>
          <button
            type="button"
            onClick={handleSkip}
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                          text-[#94C3E8] flex items-center"
            style={{ fontWeight: 600 }}
          >
            {t('skip')}
          </button>
          {currentSlide === slidesData.length - 1 ?
            <button
              type="button"
              onClick={() => {
                debugger
                logFirebaseEvents("Carousel", "learn_More_Clicked", "learn_More_Clicked", "", "");
                climNextCallBack() 
              }}
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px]
                           text-white cursor-pointer flex items-center"
              style={{ fontWeight: 600 }}

            >
              {finalButtontextChange ? finalButtontextChange : t('Learn_More')}
              {finalButtontextChange === t('done') ? "" : <img
                src={Arrow}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                                h-[14px] ml-1"
                alt="Arrow" />}
            </button> : <button
              type="button"
              onClick={nextSlide}
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[17px] sm:text-[14px] text-[16px]
                               text-white cursor-pointer flex items-center"
              style={{ fontWeight: 600 }}
            >
              {finalButtontextChange !== t('done') ? t('next') : t('Learn_More')}
              <img
                src={Arrow}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                alt="Arrow" />
            </button>}

        </div>}

      {forWelcomeCarousel &&
        <div className="flex justify-between">
          <button
            type="button"
            onClick={iswelcomeCarouselSkipClick}
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] 
            md:text-[17px] sm:text-[13px] text-[14px] text-[#94C3E8] cursor-pointer
           flex items-center">
            {t('Skip')}
          </button> 

          <button
            type="button"  
            onClick={currentSlide === slidesData.length - 1 ? kudzuplusCheckOnClick : nextSlide} 
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px]
           md:text-[17px] sm:text-[13px] text-[14px] text-[#2965FB] cursor-pointer
           flex items-center">
            {currentSlide === 0  ? t('payPerksBtn') : t('next')} 
            <img
              src={blueArrow}
              className="md:w-[17px] sm:w-[11px] md:h-[17px] sm:h-[11px] w-[12px] h-[12px]
     ml-2"
              alt="Arrow"
            />
          </button>
        </div>
      }

    </>
  );
}
